import React from 'react';

// Sliders/filter-controls glyph for the search field filters badge. No
// equivalent exists in @hero/ui-kit/icons, so it lives here as a local icon.
const FiltersIcon: React.FC = () => (
    <svg width="30" height="30" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        {/* row 1 */}
        <line
            x1="3"
            y1="6"
            x2="6"
            y2="6"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
        />
        <line
            x1="12"
            y1="6"
            x2="21"
            y2="6"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
        />
        <circle cx="9" cy="6" r="2.5" stroke="currentColor" strokeWidth="1.5" />
        {/* row 2 */}
        <line
            x1="3"
            y1="12"
            x2="12"
            y2="12"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
        />
        <line
            x1="18"
            y1="12"
            x2="21"
            y2="12"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
        />
        <circle cx="15" cy="12" r="2.5" stroke="currentColor" strokeWidth="1.5" />
        {/* row 3 */}
        <line
            x1="3"
            y1="18"
            x2="8"
            y2="18"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
        />
        <line
            x1="14"
            y1="18"
            x2="21"
            y2="18"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
        />
        <circle cx="11" cy="18" r="2.5" stroke="currentColor" strokeWidth="1.5" />
    </svg>
);

export default FiltersIcon;
